// extracted by mini-css-extract-plugin
module.exports = {"leftMenu":"LeftMenuSection_leftMenu__L0mxZ","sticky":"LeftMenuSection_sticky__0P7bk"};